import { Link } from 'react-router'
import { ROUTES } from '../config/constants'

export function NotFound() {
  return (
    <div className="p-6 space-y-3">
      <h1 className="text-lg font-bold">Page not found</h1>
      <Link to={ROUTES.home} className="text-sm text-primary underline">
        Go home
      </Link>
    </div>
  )
}
